import { useRedirectIfUnauthenticated } from "utils/azureAD/useRedirectIfUnauthenticated";
import { getHomePageInfoAsync } from "HomePage/homePage.service";
import { useMutation, useQuery } from "react-query";

export const useGetHomePageInfo = () => {
  const { accounts } = useRedirectIfUnauthenticated();

  const username = accounts[0]?.username;
  
  return useQuery(
    ["homePageInfo", {username}],
    () => getHomePageInfoAsync(username),
    { 
      enabled: navigator.onLine,
      refetchOnReconnect: false 
    }
  );
};

export const useMutateGetHomePageInfo = () => {
  const { accounts } = useRedirectIfUnauthenticated();

  return useMutation(() => getHomePageInfoAsync(accounts?.[0].username));
};
